import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ReconciliationPage } from '@/features/collections';
import { currentPeriod } from '@/shared/lib/dates';
import { zSearchText } from '@/shared/lib/search';

export const Route = createFileRoute('/_app/collections/reconciliation/')({
  validateSearch: z.object({ import: zSearchText() }),
  staticData: { crumb: 'collections:nav.reconciliation' },
  component: function Reconciliation() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <ReconciliationPage
        period={search.period ?? currentPeriod()}
        bank={search.bank}
        onScopeChange={(patch) => void navigate({ search: (prev) => ({ ...prev, ...patch }) })}
        importOpen={search.import === '1'}
        onImportChange={(open) =>
          void navigate({
            search: (prev) => ({ ...prev, import: open ? '1' : undefined }),
            replace: !open,
          })
        }
      />
    );
  },
});
